import { render, staticRenderFns } from "./test-view.vue?vue&type=template&id=39549ae9&scoped=true&"
import script from "./test-view.vue?vue&type=script&lang=ts&"
export * from "./test-view.vue?vue&type=script&lang=ts&"
import style0 from "./test-view.vue?vue&type=style&index=0&id=39549ae9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39549ae9",
  null
  
)

export default component.exports